import React,{
useEffect,
useState,
useRef,
useCallback
} from "react";

import {
useParams,
useLocation
} from "react-router-dom";

import API from "../services/api";

import html2canvas from "html2canvas";

import jsPDF from "jspdf";

import "./EmployeeSummary.css";

export default function EmployeeSummary(){

const { id } = useParams();

const location = useLocation();

const queryParams =
new URLSearchParams(
location.search
);

const month =
queryParams.get("month");

const year =
queryParams.get("year");

const [data,setData] =
useState(null);

const invoiceRef =
useRef();

const fetchSummary =
useCallback(async()=>{

try{

const res =
await API.get(
`/summary/${id}`,
{
params:{
month,
year
}
}
);

setData(res.data);

}catch(err){

console.log(err);

}

},[id,month,year]);

useEffect(()=>{

fetchSummary();

},[fetchSummary]);

const downloadPDF =
async()=>{

try{

const input =
invoiceRef.current;

const canvas =
await html2canvas(
input,
{
scale:2,
useCORS:true,
logging:false
}
);

const imgData =
canvas.toDataURL(
"image/png"
);

const pdf =
new jsPDF({
orientation:"portrait",
unit:"mm",
format:"a4"
});

const pdfWidth =
pdf.internal.pageSize.getWidth();

const pdfHeight =
(canvas.height *
pdfWidth) /
canvas.width;

pdf.addImage(
imgData,
"PNG",
0,
0,
pdfWidth,
pdfHeight
);

pdf.save(
`${data.name}_${month}_${year}_Invoice.pdf`
);

}catch(err){

console.log(err);

alert(
"PDF Download Failed"
);

}

};

if(!data){

return(

<h1
style={{
textAlign:"center",
marginTop:"50px"
}}
>
Loading...
</h1>

);

}

const attendanceAmount =
  Number(data.attendanceAmount || 0);

const expenseAmount =
  Number(data.expenseAmount || 0);

const reimbursementAmount =
  Number(data.reimbursementAmount || 0);

const deduction = 250;

const adjustedExpense =
  expenseAmount > 250
    ? expenseAmount - deduction
    : 0;

const total =
  attendanceAmount +
  adjustedExpense +
  reimbursementAmount;

return(

<div className="main-wrapper">

<div
className="invoice-container"
ref={invoiceRef}
>

<div className="invoice-header">

<div>

<h1>
UP2DATE TECHNOLOGY
SOLUTIONS LLC
</h1>

<p>
Employee Invoice Summary
</p>

</div>

<div className="invoice-right">

<h2>
INVOICE
</h2>

<p>
Invoice No :
UP2DATE00{id}
</p>

<p>
Date :
{new Date().toLocaleDateString()}
</p>

<p>
Month :
{month || "All"}
</p>

<p>
Year :
{year || "All"}
</p>

</div>

</div>

<div className="employee-section">

<div className="employee-box">

<h3>
TO
</h3>
<p>{data.employeeName}</p>
<p>
Up2Date Technology Solution
</p>

<p>
San Jose, CA 95113,
USA
</p>

</div>

<div className="employee-box">

<h3>
FROM :
</h3>

<p>
Up2Date Technology Solution
</p>

<p>
San Jose, CA 95113,
</p>

<p>USA</p>

</div>

</div>

<table className="invoice-table">

<thead>

<tr>

<th>
Sl No
</th>

<th>
Description
</th>

<th>
Hours
</th>

<th>
Rate
</th>

<th>
Deduction
</th>

<th>
Amount
</th>

</tr>

</thead>

<tbody>

<tr>

<td>
1
</td>

<td>
Attendance Payment
</td>

<td>
{data.workingHours || 0} hrs
</td>

<td>
₹ {data.ratePerHour || 0}
</td>

<td>
-
</td>

<td>
₹ {attendanceAmount}
</td>

</tr>

<tr>

<td>
2
</td>

<td>
{data.expenseDescription ||
"Weekly Expense"}
</td>

<td>
-
</td>

<td>
-
</td>

<td>
₹ {deduction}
</td>

<td>
₹ {expenseAmount}
</td>

</tr>

<tr>

<td>
3
</td>

<td>
Reimbursement
</td>

<td>
-
</td>

<td>
-
</td>

<td>
-
</td>

<td>
₹ {reimbursementAmount}
</td>

</tr>

</tbody>

</table>

<div className="total-section">
<h4>
NET AMOUNT :
₹ {total}
</h4>

</div>

<div className="invoice-footer">

<p>
Thank you for your hardwork and dedication!
</p>

</div>

</div>

<div className="download-section">

<button
className="download-btn"
onClick={downloadPDF}
>
Download Invoice PDF
</button>

</div>

</div>

);

}